export default __webpack_public_path__ + "static/media/youtube-svgrepo-com (1).dd044bf8.svg";